export const localizeURL = (lang, url) => {
  const locale = lang
  const key = locale.toLowerCase()
  const localeRegex = /^(\/en-us\/|\/es-mx\/)/
  const localizedURL = `/${key}/${url.replace(localeRegex, '')}`
  return localizedURL
}
